<template>
  <el-dialog
    :title="$t('transactionLogMessage.logMessage')"
    :visible.sync="dialogVisible"
    width="80%"
    top="5vh"
  >
    <el-form label-position="top">
      <el-form-item :label="$t('transactionLogMessage.requestHeader')">
        <el-input
          type="textarea"
          :rows="3"
          v-model="transactionLogMessageInfo.requestHeader"
          readonly
        />
      </el-form-item>
      <el-form-item :label="$t('transactionLogMessage.requestMessage')">
        <el-input
          type="textarea"
          :rows="4"
          v-model="transactionLogMessageInfo.requestMessage"
          readonly
        />
      </el-form-item>
      <el-form-item :label="$t('transactionLogMessage.responseHeader')">
        <el-input
          type="textarea"
          :rows="3"
          v-model="transactionLogMessageInfo.responseHeader"
          readonly
        />
      </el-form-item>
      <el-form-item :label="$t('transactionLogMessage.responseMessage')">
        <el-input
          type="textarea"
          :rows="4"
          v-model="transactionLogMessageInfo.responseMessage"
          readonly
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="warning" @click="dialogVisible = false">
        {{ $t('transactionLogMessage.cancel') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryTransactionLogMessage } from '@/api/dev/transactionLogApi'

export default {
  name: 'TransactionLogMessage',
  data() {
    return {
      dialogVisible: false,
      transactionLogMessageInfo: {
        logId: '',
        requestHeader: '',
        responseHeader: '',
        requestMessage: '',
        responseMessage: ''
      }
    }
  },
  methods: {
    open(log) {
      this.transactionLogMessageInfo.logId = log.logId
      this.clearLogMessage()
      this.getLogMessage(log)
      this.dialogVisible = true
    },
    async getLogMessage(param) {
      try {
        const res = await queryTransactionLogMessage({ logId: param.logId })
        if (res.data && res.data.length > 0) {
          Object.assign(this.transactionLogMessageInfo, res.data[0])
        }
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    clearLogMessage() {
      this.transactionLogMessageInfo = {
        logId: '',
        requestHeader: '',
        responseHeader: '',
        requestMessage: '',
        responseMessage: ''
      }
    }
  }
}
</script>

<style scoped>
.el-textarea /deep/ .el-textarea__inner {
  font-family: monospace;
  white-space: pre;
}
</style>